<template>
  <div class="product-banner">
    <el-image :src="images[activeIndex]"></el-image>
    <div class="swiper">
      <i class="el-icon-arrow-left prev"></i>
      <swiper ref="swiper" :options="swiperOptions">
        <swiper-slide v-for="(v,i) in images" :key="i">
          <el-image :src="v" @click.prevent="clickImage(i)"></el-image>
        </swiper-slide>
      </swiper>
      <i class="el-icon-arrow-right next"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBanner',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    swiperOptions() {
      const that = this
      return {
        slidesPerView: 3,
        slideToClickedSlide: false,
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = document.getElementsByClassName('swiper-container')[0].swiper.activeIndex
          }
        }
      }
    }
  },
  methods: {
    /**
     * 点击图片
     * @param index
     */
    clickImage(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style scoped lang="scss">
.product-banner {
  width: 100%;
  display: flex;
  flex-direction: column;

  .swiper {
    width: 100%;
    height: 54px;
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .swiper-container {
      margin: 0 20px;

      .swiper-slide {
        width: 54px !important;
        height: 54px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }

        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }

    i {
      height: 100%;
      line-height: 54px;
      font-size: 30px;
      color: #6C6C6C;
      font-weight: bold;
      cursor: pointer;
    }

  }
}
</style>